
const currentStageFieldID = '.broker-stage-field input';
const currentPageFieldID = '.broker-page-field input';
const saveForLaterFieldID = '.broker-save-field input';
const signatureFieldID = '.broker-signature-field';
const clientChangesFieldID = '.broker-client-changes-field textarea';

const gformWrapper = document.querySelector('.gform_wrapper');
const brokerForm = document.querySelector('form[action="/broker-request-form/"]');
const formID = brokerForm.id.split("_").pop();

class BrokerClientForm {
  constructor() {
    this.setPage.bind(this);
    this.getNextButtonText.bind(this);
    this.saveButtonClick.bind(this);
    this.saveLaterButtonClick.bind(this);
	this.closeModalClick.bind(this);
    this.getSaveButtonText.bind(this);
	this.confirmSubmitPopupClick.bind(this);
    this.closeSubmitPopupClick.bind(this);
    this.signatureFieldValid.bind(this);
	this.currentPage = 0;
	this.currentStage = 0;
	this.firstPage = 0;
	this.originalFields = [];

	// Check on broker form page
	if (!brokerForm){
		return false;
	}

	var myThis = this;

	// Initialise total pages var
	const pageSections = document.querySelectorAll('.gsection:not(.security-address-section)');
	if (pageSections.length > 0){
		this.totalPages = pageSections.length;
	}

	// Set current stage
	const currentStageField = document.querySelector(currentStageFieldID);
	if (currentStageField){
		brokerForm.setAttribute('data-broker-stage', currentStageField.value);
		this.currentStage = parseInt(currentStageField.value);
		currentStageField.value = this.currentStage+1; //For submission
		if (this.currentStage == 1){
			document.querySelector('.client-email-field').style.display = 'none';
		}
		if (this.currentStage != 1 && this.currentStage != 3){
			this.firstPage = 1;
			this.currentPage = 1;
		}
		if (this.currentStage == 3){
			document.querySelector('.application-type-field').style.display = 'none';
			document.querySelector('.loan-type-field').style.display = 'none';
			document.querySelector('.msp-team-member-name-field').style.display = 'none';
			document.querySelector('.msp-team-member-email-field').style.display = 'none';
			document.querySelector('.broker-name-field').style.display = 'none';
			document.querySelector('.broker-email-field').style.display = 'none';
			document.querySelector('.reference-number-field').style.display = 'none';
		} else {
			document.querySelector('.client-email-field').classList.remove("gfield_contains_required");
		}
		if (this.currentStage != 4){
			document.querySelector(signatureFieldID).style.display = "none";
		}
	}

	// Disable Enter button to submit
	brokerForm.addEventListener('keypress', function(e) {
		if (e.keyCode === 13 && e.target.tagName != "TEXTAREA") {
			e.preventDefault();
		}
	});

	// Validate
	document.addEventListener('DOMContentLoaded', function() {
		if ( !jQuery.validator instanceof Function) {
		  return;
		}

		var validationOptions = {
		  ignore: [],
		  rules: {},
		};

		const dateRegex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
		jQuery.validator.addMethod("dateUK", function(value, element) {
			return (dateRegex.test(value));
		}, "* Incorrect date format");

		if (myThis.currentStage == 1 || myThis.currentStage == 3){
			// Only validate first page
		
			const pageSections = document.querySelectorAll('.gsection:not(.security-address-section)');
			var nextField = pageSections[myThis.firstPage].nextElementSibling;

			while(
				nextField && 
				(!nextField.classList.contains('gsection') || 
				nextField.classList.contains('security-address-section'))
			){
				var nextFieldInput = jQuery(nextField).find('input');

				if (nextField.classList.contains("gfield_contains_required") && nextFieldInput){
					var ruleName = nextFieldInput.attr('name');
					if (!validationOptions.rules.hasOwnProperty(ruleName)) {
						validationOptions.rules[ruleName] = {
						  required: true,
						};
					}
				}

				nextField = nextField.nextElementSibling;
			}

		} else if (myThis.currentStage == 2) {
			// Validate all fields

			jQuery(this).find('.gfield_contains_required input:not([type="hidden"]), .gfield_contains_required select, .gfield_contains_required textarea').each(function(i) {
				var ruleName = jQuery(this).attr('name');
				if (!validationOptions.rules.hasOwnProperty(ruleName)) {
					validationOptions.rules[ruleName] = {
						required: true,
					};
					if (jQuery(this).hasClass('datepicker')){
						validationOptions.rules[ruleName].dateUK = true;
					}
				}
			});
		} else if (myThis.currentStage == 4) {

			// Record original field values
			myThis.originalFields = jQuery(document.querySelector('form[action="/broker-request-form/"]')).find('input, textarea, select').get().map(item => {

				// Get label
				var label = ''
				var gfield = item.closest('.gfield');
				if (gfield){
					label = gfield.querySelector('.gfield_label').innerText.replace('(Required)', '');
				}
				var sublabel = item.parentElement.querySelector('label');
				if (sublabel){
					label = [label, sublabel.innerText].join(' - ');
				}
				// Get section
				var section_title = ''
				var gsection = item.closest('.gfield');
				while (gsection && !gsection.classList.contains('gsection')){
					gsection = gsection.previousElementSibling;
				}
				if (gsection){
					var gtitle = gsection.querySelector('.gsection_title');
					if (gtitle) {
						section_title = gtitle.innerText;
					}
				}			

				return {name: item.name, label: label, originalValue: item.value, section: section_title, changed: false}
			});
			console.log("originalFields", myThis.originalFields)

			// Change listener
			jQuery(brokerForm).find('input, textarea, select').on( "change", function() {
				console.log( "Handler for `change` called.", this.name );
				// console.log( jQuery( this ).val() );
				var field = myThis.originalFields.find(item => item.name == this.name);
				if (this.value != field.originalValue){
					field.changed = true;
				} else {
					field.changed = false;
				}
				// console.log("originalFields", myThis.originalFields.filter(item => item.changed == true).map(item => item.section+': '+item.label).join('\n'))
			} );

			// Validate all fields
			jQuery(this).find('.gfield_contains_required input:not([type="hidden"]), .gfield_contains_required select, .gfield_contains_required textarea').each(function(i) {
				var ruleName = jQuery(this).attr('name');
				if (!validationOptions.rules.hasOwnProperty(ruleName)) {
					validationOptions.rules[ruleName] = {
						required: true,
					};
					if (jQuery(this).hasClass('datepicker')){
						validationOptions.rules[ruleName].dateUK = true;
					}
				}
			});

			jQuery.validator.addMethod("signatureValid", function(value, element) {
				// console.log("value", value, element.parentElement.querySelector('canvas'))
				// return (parseFloat(value) > 0);
				// if (value){
					console.log("myThis.signatureFieldValid()", myThis.signatureFieldValid())
				return myThis.signatureFieldValid();
			}, "* Signature must be entered");

			// Validate signature field
			var ruleName = 'input_'+formID+'_142_data';
			if (!validationOptions.rules.hasOwnProperty(ruleName)) {
				validationOptions.rules[ruleName] = {
					signatureValid: true,
				};
			}

		}

		console.log("validationOptions.rules", validationOptions.rules)

		if (Object.keys(validationOptions.rules).length > 0) {
			  window.brokerValidator = jQuery(brokerForm).validate(validationOptions);
		}
	});

	// Add previous/next buttons
	const formFooter = document.querySelector('.gform_footer');
	if (formFooter){

		var previousButton = document.createElement('input');
		previousButton.classList.add('gform_previous_button', 'button', 'btn', 'btn-primary');
		previousButton.value = "Previous";
		previousButton.type = "button";
		previousButton.onclick = function(event){
			var isCompanyLoan = document.querySelector(`#choice_${formID}_160_1`).checked;
			if (!isCompanyLoan && (myThis.currentPage-1 == 2 || myThis.currentPage-1 == 6)){
				myThis.setPage(myThis.currentPage-2);
			} else {
				myThis.setPage(myThis.currentPage-1);
			}
		}

		var nextButton = document.createElement('input');
		nextButton.classList.add('gform_next_button', 'button', 'btn', 'btn-primary');
		nextButton.value = this.getNextButtonText();
		nextButton.type = "button";
		nextButton.onclick = function(event){
			var isCompanyLoan = document.querySelector(`#choice_${formID}_160_1`).checked;
			if (!isCompanyLoan && (myThis.currentPage+1 == 2 || myThis.currentPage+1 == 6)){
				myThis.setPage(myThis.currentPage+2);
			} else {
				myThis.setPage(myThis.currentPage+1);
			}
		}
		
		formFooter.prepend(nextButton);
		formFooter.prepend(previousButton);

		var buttonsDiv = document.createElement('div');
		buttonsDiv.classList.add('broker-buttons-container');
		formFooter.append(buttonsDiv);

		var saveSubmitButton = document.createElement('button');
		saveSubmitButton.classList.add('broker-save-button', 'btn', 'btn-primary');
		saveSubmitButton.innerText = this.getSaveButtonText();
		saveSubmitButton.addEventListener("click", this.saveButtonClick.bind(this), false);
		saveSubmitButton.type = "button";
		if (myThis.currentStage == 4) {
			setTimeout(function(){
				if (myThis.signatureFieldValid()) {
					saveSubmitButton.removeAttribute("disabled");
				} else {
					saveSubmitButton.setAttribute("disabled", "");
				}
			},500);
			// console.log(jQuery('canvas#input_'+formID+'_142, #input_'+formID+'_142_resetbutton').length)
			// jQuery('canvas#input_'+formID+'_142, #input_'+formID+'_142_resetbutton').on( "click drag dragstart mousedown dragend mouseup", function() {
			jQuery('body').on('click drag dragstart mousedown dragend mouseup', 'canvas#input_'+formID+'_142, #input_'+formID+'_142_resetbutton', function(event) {
				if (myThis.signatureFieldValid()) {
					saveSubmitButton.removeAttribute("disabled");
				} else {
					saveSubmitButton.setAttribute("disabled", "");
				}
			} );
		}
		buttonsDiv.append(saveSubmitButton);

		if (this.currentStage == 2) {

			var saveLaterButton = document.createElement('button');
			saveLaterButton.classList.add('broker-saveforlater-button', 'btn', 'btn-secondary');
			saveLaterButton.innerHTML = '<svg aria-hidden="true" focusable="false" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 8a4 4 0 004 4h3v3a1 1 0 102 0v-3h3a4 4 0 100-8 4 4 0 10-8 0 4 4 0 00-4 4zm9 4H7V7.414L5.707 8.707a1 1 0 01-1.414-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L9 7.414V12z" fill="#6B7280"></path></svg> Save for later';
			saveLaterButton.addEventListener("click", this.saveLaterButtonClick.bind(this), false);
			saveLaterButton.type = "button";
			buttonsDiv.append(saveLaterButton);

		}

		const customErrorMessage = document.createElement('p');
		customErrorMessage.classList.add('broker-error-message');
		formFooter.append(customErrorMessage);

		const brokerPopupBG = document.createElement('div');
		brokerPopupBG.classList.add('broker-popup-bg');
		brokerPopupBG.addEventListener("click", this.closeModalClick.bind(this), false);
		document.querySelector('body').append(brokerPopupBG);

		const brokerPopupMessage = document.createElement('p');
		brokerPopupMessage.classList.add('broker-popup-message');
		brokerPopupMessage.innerText = "In order to give the most accurate terms, there are some parts of the form that we require answers to. Please fill in all the below fields before submitted the form for our review.";
		document.querySelector('.gform_heading').append(brokerPopupMessage);

		const submitPopup = document.createElement('div');
		submitPopup.classList.add('broker-submit-popup');

		const brokerPopupCross = document.createElement('button');
		brokerPopupCross.classList.add('broker-submit-popup-cross', 'close');
		brokerPopupCross.type = "button";
		brokerPopupCross.innerHTML = '<span aria-hidden="true">×</span>';
		brokerPopupCross.addEventListener("click", this.closeModalClick.bind(this), false);
		gformWrapper.prepend(brokerPopupCross);

		const submitPopupConfirm = document.createElement('button');
		submitPopupConfirm.classList.add('broker-submit-popup-confirm', 'btn', 'btn-primary');
		submitPopupConfirm.type = "button";
		submitPopupConfirm.innerHTML = 'Confirm';
		submitPopupConfirm.addEventListener("click", this.confirmSubmitPopupClick.bind(this), false);
		submitPopup.prepend(submitPopupConfirm);

		const submitPopupCancel = document.createElement('button');
		submitPopupCancel.classList.add('broker-submit-popup-cancel', 'btn');
		submitPopupCancel.type = "button";
		submitPopupCancel.innerHTML = 'Cancel';
		submitPopupCancel.addEventListener("click", this.closeSubmitPopupClick.bind(this), false);
		submitPopup.prepend(submitPopupCancel);

		const submitPopupText = document.createElement('p');
		submitPopupText.innerText = "Once you submit this data, this form will no longer be accessible";
		submitPopup.prepend(submitPopupText);

		const submitPopupTitle = document.createElement('h3');
		submitPopupTitle.innerText = "Notice";
		submitPopup.prepend(submitPopupTitle);

		const submitPopupCross = document.createElement('button');
		submitPopupCross.classList.add('broker-popup-cross', 'close');
		submitPopupCross.type = "button";
		submitPopupCross.innerHTML = '<span aria-hidden="true">×</span>';
		submitPopupCross.addEventListener("click", this.closeSubmitPopupClick.bind(this), false);
		submitPopup.prepend(submitPopupCross);
		gformWrapper.prepend(submitPopup);
		
	}

	// Set initial page
	const currentPageField = document.querySelector(currentPageFieldID);
	const saveForLaterField = document.querySelector(saveForLaterFieldID);
	if (saveForLaterField.value == "true" && currentPageField){
		this.setPage(parseInt(currentPageField.value));
	} else {
		this.setPage(this.firstPage);
	}
	saveForLaterField.value = "false";

  }

  signatureFieldValid() {
	var canvasValue = document.querySelector('#input_'+formID+'_142_data').value;
	if (canvasValue && canvasValue != "") {
		return true;
	} else {
		return false;
	}
  }

  confirmSubmitPopupClick(event) {
	const currentStageField = document.querySelector(currentStageFieldID);
	currentStageField.value = this.currentStage; //For submission
	const submitButton = document.querySelector('.gform_footer button.btn-primary.gform_button');
	submitButton.click();
  }

  closeSubmitPopupClick(event) {
	document.querySelector('.broker-submit-popup').classList.remove('show');
	document.querySelector('.broker-popup-bg').classList.remove('show');
	document.querySelector('html').classList.remove('noscroll');
  }

  closeModalClick(event) {
	gformWrapper.classList.remove('popup');
	document.querySelector('.broker-submit-popup').classList.remove('show');
	document.querySelector('.broker-popup-bg').classList.remove('show');
	document.querySelector('html').classList.remove('noscroll');
    window.brokerValidator.resetForm();
	this.setPage(this.firstPage);
  }

  saveLaterButtonClick(event) {
	if (this.currentStage == 2) { //Broker

		window.brokerValidator.destroy();
		
		const currentStageField = document.querySelector(currentStageFieldID);
		currentStageField.value = this.currentStage; //Reset

		const saveForLaterField = document.querySelector(saveForLaterFieldID);
		saveForLaterField.value = "true";

		const saveButton = document.querySelector('.gform_save_link');
		saveButton.click();
	}
  }

  saveButtonClick(event) {

	const clientChangesField = document.querySelector(clientChangesFieldID);
	var changedLabels = this.originalFields.filter(item => item.changed == true).map(item => item.section+': '+item.label);
	if (clientChangesField.value != ''){
		clientChangesField.value = clientChangesField.value + '\n' + changedLabels.join('\n')
	} else {
		clientChangesField.value = changedLabels.join('\n')
	}

	if (this.currentStage == 1 || this.currentStage == 3){
		brokerForm.classList.add('show-all-fields');
		var isValid = window.brokerValidator.form();
		brokerForm.classList.remove('show-all-fields');
	
		const customErrorMessage = document.querySelector('.broker-error-message');
		customErrorMessage.innerHTML = "";
		if (!isValid){
			this.setPage(this.firstPage);
			customErrorMessage.innerHTML = "Please complete all the setup fields.";
		} else {
			const saveButton = document.querySelector('.gform_save_link');
			saveButton.click();
		}
	} else if (this.currentStage == 2 || this.currentStage == 4) { //Broker/client
		brokerForm.classList.add('show-all-fields');
		var isValid = window.brokerValidator.form();
		brokerForm.classList.remove('show-all-fields');

		console.log("isValid", isValid)
		
		if (!isValid){
			gformWrapper.classList.add('popup');
			document.querySelector('.broker-popup-bg').classList.add('show');
			document.querySelector('html').classList.add('noscroll');
	
			// Show invalid fields
			document.querySelectorAll('.gfield.currentPage').forEach(element => {
				element.classList.remove('currentPage');
			})
			const pageSections = document.querySelectorAll('.gsection:not(.security-address-section)');
			var nextField = pageSections[this.firstPage];
			var currentSection = nextField;
			var sectionContainsError = false;
	
			while(
				nextField
			){
				if (nextField.classList.contains('gsection')){
					if (sectionContainsError == false){
						currentSection.classList.remove('currentPage');
					}
					nextField.classList.add('currentPage');
					sectionContainsError = false;
					currentSection = nextField;
				}
				if (nextField.classList.contains('gfield_contains_required') && nextField.style.display != "none"){
					var allFieldsValid = nextField.querySelector('.valid')
					if (nextField.querySelector('.ginput_complex')){
						allFieldsValid = nextField.querySelectorAll('.ginput_complex input:not(.valid), .ginput_complex select:not(.valid), .ginput_complex textarea:not(.valid)').length == 0;
					}

					if (!allFieldsValid){
						nextField.classList.add('currentPage');
						sectionContainsError = true;
						// Also show dependant fields
						if (nextField.style.display != "none"){
							
							var nextFieldClassList = [...nextField.classList];
							nextFieldClassList.forEach(depFieldClass => {
								if (depFieldClass.startsWith('req-field_')){
									if (depFieldClass){
										var depFieldID = depFieldClass.substring(4).split("_");
										depFieldID[1] = formID;
										depFieldID = depFieldID.join("_");
										document.getElementById(depFieldID).classList.add('currentPage');
									}
			
								}
							});
						}
					}
				}
				nextField = nextField.nextElementSibling;
			}
			if (sectionContainsError == false){
				currentSection.classList.remove('currentPage');
			}
			document.querySelector('.gform_heading').scrollIntoView();
		} else {
			if (this.currentStage == 2) { //Broker
				const saveButton = document.querySelector('.gform_save_link');
				saveButton.click();
			} else if (this.currentStage == 4) { //Client
				
				document.querySelector('.broker-submit-popup').classList.add('show');
				document.querySelector('.broker-popup-bg').classList.add('show');
				document.querySelector('html').classList.add('noscroll');
			}
		}
	} else if (this.currentStage == 3) { //MSP review
		const saveButton = document.querySelector('.gform_save_link');
		saveButton.click();
	}
  }

  getNextButtonText(){
	if (this.currentStage == 1 && this.currentPage == 0){
		return "Add broker/client info (optional)";
	} else {
		return "Next"
	}
  }

  getSaveButtonText(){
	if (this.currentStage == 1){
		return "Send to broker";
	} else if (this.currentStage == 2){
		return "Submit for review";
	} else if (this.currentStage == 3){
		return "Send to client";
	} else if (this.currentStage == 4){
		return "Submit";
	} else {
		return "Save for later"
	}
  }

  setPage(newPage){

	// Exit if impossible
	if (newPage < this.firstPage || newPage > this.totalPages){
		return false;
	}

	// Set page field
	const currentPageField = document.querySelector(currentPageFieldID);
	currentPageField.value = newPage;
	brokerForm.setAttribute('data-broker-page', newPage);

	// Hide current page
	var visibleSections = document.querySelectorAll('.gfield.currentPage');
	visibleSections.forEach(element => {
		element.classList.remove('currentPage');
	});
	
	// Display new page
	const pageSections = document.querySelectorAll('.gsection:not(.security-address-section)');
	pageSections[newPage].classList.add('currentPage');
	var nextField = pageSections[newPage].nextElementSibling;
	while(nextField && (!nextField.classList.contains('gsection') || nextField.classList.contains('security-address-section'))){
		nextField.classList.add('currentPage');
		nextField = nextField.nextElementSibling;
	}

	// Scroll to top
	if (newPage != this.currentPage){
		document.querySelector('.gform_heading').scrollIntoView();
	}

	this.currentPage = newPage;

	// Reset buttons
	var previousButton = document.querySelector('.gform_previous_button');
	var nextButton = document.querySelector('.gform_next_button');
	if (newPage == this.firstPage){
		previousButton.setAttribute("disabled", "");
		nextButton.removeAttribute("disabled");
	} else if (newPage == this.totalPages-1){
		previousButton.removeAttribute("disabled");
		nextButton.setAttribute("disabled", "");
	} else {
		previousButton.removeAttribute("disabled");
		nextButton.removeAttribute("disabled");
	}
	nextButton.value = this.getNextButtonText();
  }
}

export default new BrokerClientForm;